import * as yup from 'yup'
import { I18n } from 'react-redux-i18n'

const schema = yup
  .object()
  .shape({
    code: yup.string().required(I18n.t('RequiredCode')),
  })
  .required()
  .noUnknown()

export default schema
